export default __webpack_public_path__ + "static/media/background-black-tint.3e1dbfae.jpg";